import { Navigate, useLocation, useNavigate } from 'react-router-dom'
import { CheckCircle2 } from 'lucide-react'
import { Button } from '@/core/ui/Button'
import { useIsAuthenticated } from '@/core/auth/SessionStore'
import type { PushSummary } from '@/core/sync/carreteiroSync'

interface State {
  resumo?: string
  pushResult?: PushSummary | null
}

export function ParteDiariaSuccessRoute() {
  const authed = useIsAuthenticated()
  const navigate = useNavigate()
  const location = useLocation()
  const state = (location.state ?? {}) as State

  if (!authed) return <Navigate to="/login" replace />

  const push = state.pushResult
  let label: string
  let tone: 'ok' | 'warn' | 'bad'
  let detail: string | null = null

  if (push == null) {
    label = 'Aguardando sincronização'
    tone = 'warn'
  } else if (push.rejected > 0) {
    label = `${push.rejected} lançamento(s) recusado(s) pelo servidor`
    tone = 'bad'
    detail = `${push.errors.join('; ')} — veja em Parte Diária → Recusadas pelo servidor.`
  } else if (push.failed > 0 && push.accepted === 0) {
    label = 'Sem conexão — fila pendente'
    tone = 'warn'
  } else if (push.failed > 0) {
    label = `${push.accepted} enviado(s), ${push.failed} aguardando reenvio`
    tone = 'warn'
  } else if (push.accepted > 0) {
    label = 'Gravado no SIGA'
    tone = 'ok'
  } else {
    label = 'Nada para sincronizar'
    tone = 'warn'
  }

  const toneCls = tone === 'ok' ? 'bg-ok/10 text-ok' : tone === 'warn' ? 'bg-warn/10 text-warn' : 'bg-bad/10 text-bad'

  return (
    <main className="min-h-svh bg-bg-base flex flex-col items-center justify-center p-6">
      <div className="max-w-md w-full text-center">
        <CheckCircle2 className="h-20 w-20 text-ok mx-auto" />
        <h1 className="text-2xl font-bold text-on-surface mt-4">Parte diária salva</h1>
        <p className="text-on-surface-dim mt-2">{state.resumo ?? 'lançamento'} salvo(s) localmente.</p>

        <div className={`mt-6 rounded-lg px-4 py-3 text-sm ${toneCls}`}>
          <p className="font-medium">{label}</p>
          {detail && <p className="text-xs mt-1 opacity-80">{detail}</p>}
        </div>

        <div className="mt-8 space-y-3">
          {push != null && push.rejected > 0 && (
            <Button variant="outline" size="lg" onClick={() => navigate('/parte-diaria', { replace: true })} className="w-full">
              Ver recusadas
            </Button>
          )}
          <Button variant="outline" size="lg" onClick={() => navigate('/parte-diaria/step0', { replace: true })} className="w-full">
            Lançar outro equipamento
          </Button>
          <Button variant="primary" size="lg" onClick={() => navigate('/', { replace: true })} className="w-full">
            Voltar para Home
          </Button>
        </div>
      </div>
    </main>
  )
}
